import { ChevronDownIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

import { useCurrentUser, useUpdateUser } from 'services/repositories/user/user';

import { HeaderMenuButton } from './HeaderMenuButton/HeaderMenuButton';

type MenuButtonItem = Parameters<typeof HeaderMenuButton>['0']['items'][0];
export const LanguageSwitcher = () => {
  const { data: currentUser, isLoading } = useCurrentUser();
  const { mutate } = useUpdateUser();

  if (isLoading || !currentUser) {
    return null;
  }

  const menuItems: Array<MenuButtonItem> = [
    { value: 'English', onClick: () => mutate({ ...currentUser, language: 'en' }) },
    { value: 'Deutsch', onClick: () => mutate({ ...currentUser, language: 'de' }) },
  ];

  const trigger = (
    <div className="flex items-center justify-between space-x-3">
      <GlobeAltIcon className="size-4" />
      <div className="text-sm font-medium text-gray-700">{currentUser?.language.toUpperCase()}</div>
      <ChevronDownIcon className="size-4" />
    </div>
  );

  return <HeaderMenuButton trigger={trigger} items={menuItems} menuAlignment="left" />;
};
